/* =========================================================================
   Lozea — general UI behaviour (no framework)
   Scroll reveals, sticky-header state, mobile nav, FAQ accordion,
   marquee duplication, PDP gallery + bundle radios.
   ========================================================================= */
(function () {
  'use strict';

  /* ---- scroll reveal ---- */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.lz-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.transitionDelay = (entry.target.dataset.delay || '0') + 'ms';
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- sticky header state ---- */
  function initHeader() {
    var header = document.querySelector('.lz-header');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var burger = header.querySelector('.lz-burger');
    var nav = document.querySelector('.lz-mobile-nav');
    if (burger && nav) {
      burger.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', String(open));
      });
      nav.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          nav.classList.remove('is-open');
          burger.setAttribute('aria-expanded', 'false');
        });
      });
    }
  }

  /* ---- FAQ accordion ---- */
  function initFaq(root) {
    (root || document).querySelectorAll('.lz-faq__item').forEach(function (item) {
      var btn = item.querySelector('.lz-faq__q');
      if (!btn || btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }

  /* ---- marquee: duplicate content so it loops seamlessly ---- */
  function initMarquee(root) {
    (root || document).querySelectorAll('.lz-marquee__track:not([data-doubled])').forEach(function (track) {
      track.setAttribute('data-doubled', '1');
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* ---- PDP: thumbnail gallery ---- */
  function initPdpGallery(root) {
    (root || document).querySelectorAll('[data-lz-gallery]').forEach(function (gallery) {
      if (gallery.dataset.bound) return;
      gallery.dataset.bound = '1';
      var main = gallery.querySelector('[data-lz-main]');
      gallery.querySelectorAll('[data-lz-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main) return;
          main.src = thumb.dataset.lzThumb;
          main.alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : main.alt;
          gallery.querySelectorAll('[data-lz-thumb]').forEach(function (t) {
            t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
          });
        });
      });
    });
  }

  /* ---- PDP: reflect selected bundle/variant radio into the buy form ---- */
  function initVariantRadios(root) {
    (root || document).querySelectorAll('[data-lz-variant-form]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';
      var idInput = form.querySelector('input[name="id"]');
      var priceOut = form.querySelector('[data-lz-current-price]');
      var compareOut = form.querySelector('[data-lz-current-compare]');
      var addBtn = form.querySelector('button[name="add"]');
      var addLabel = addBtn && addBtn.querySelector('[data-lz-add-label]');
      var express = form.querySelector('[data-lz-express]');
      form.querySelectorAll('input[data-lz-variant]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          // radios are themselves name="id" — only sync a separate hidden input
          if (idInput && idInput.type !== 'radio') idInput.value = radio.value;
          if (priceOut && radio.dataset.price) priceOut.textContent = radio.dataset.price;
          if (compareOut) {
            compareOut.textContent = radio.dataset.compare || '';
            compareOut.hidden = !radio.dataset.compare;
          }
          var available = !radio.disabled;
          if (addBtn) addBtn.disabled = !available;
          if (addLabel) addLabel.textContent = available ? (addLabel.dataset.available || 'Add to bag') : 'Sold out';
          if (express) express.hidden = !available;
        });
      });
    });
  }

  /* ---- parallax hero watchdog ----
     If lozea-planet.js (an ES module importing three.js from a CDN) fails to
     boot, don't leave the visitor with ~300vh of empty scroll: collapse the
     pinned section and reveal the last headline. */
  function initHeroWatchdog() {
    document.querySelectorAll('.lozea-hero').forEach(function (hero) {
      setTimeout(function () {
        if (hero.dataset.lzReady === '1' || hero.querySelector('canvas')) return;
        hero.style.minHeight = '100vh';
        var phrases = hero.querySelectorAll('.lz-hero__phrase');
        if (phrases.length) phrases[phrases.length - 1].style.opacity = '1';
        var cue = hero.querySelector('.lz-hero__cue');
        if (cue) cue.style.opacity = '0';
      }, 2800);
    });
  }

  function initAll(root) {
    initReveals(root);
    initFaq(root);
    initMarquee(root);
    initPdpGallery(root);
    initVariantRadios(root);
    initHeroWatchdog(root);
  }

  if (document.readyState !== 'loading') { initHeader(); initAll(); }
  else document.addEventListener('DOMContentLoaded', function () { initHeader(); initAll(); });

  /* Shopify theme editor hooks */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); initHeader(); });
})();
